<span class="menuOverly"></span>
<div class="enqueryForm signuppopup" [formGroup]="enquiryForm" *ngIf="show">
    <h2>Please Fill in Your Details and We'll Call You Back!</h2>
    <span (click)="close()" class="crossBtn"></span>
    <ul class="efListwrap">
        <li>
          <span>
            <label>Name*</label>
            <input class="input" type="text" placeholder="Enter Name" formControlName="name" autocomplete="off"
                maxlength="100" />
        </span>
        <small class="error" *ngIf="submitted && myForm.name.errors?.required">
            <sup>*</sup>Enter your name
        </small>
        <small class="error" *ngIf="submitted && myForm.name.errors?.minlength">
            <sup>*</sup>Name must be 2 characters long
        </small>
        <small class="error" *ngIf="submitted && myForm.name.errors?.pattern">
            <sup>*</sup>Please enter a valid name
        </small>
        </li>
        <li>
          <span>
            <label>Email</label>
            <input class="input" type="text" placeholder="Enter Email" formControlName="email" autocomplete="off"
                maxlength="100" />
            </span>
            <small class="error" *ngIf="submitted && myForm.email.errors?.required">
                <sup>*</sup>Enter your email
            </small>
            <small class="error" *ngIf="submitted && myForm.email.errors?.pattern">
                <sup>*</sup>Please enter valid email
            </small>
    
        </li>
        <li>
          <span>
            <label>Mobile*</label>
            <input class="input" type="text" placeholder="+91"  autocomplete="off"
            (input)="maxLengthTen($event)"
             maxlength="10"
                formControlName="mobileNo"  inputmode="numeric"/>
            </span>
            <small class="error" *ngIf="submitted && myForm.mobileNo.errors?.required">
                <sup>*</sup>Please enter your Mobile number
            </small>
            <small class="error" *ngIf="submitted && myForm.mobileNo.errors?.minlength">
                <sup>*</sup>Please enter 10 digit Mobile Number
            </small>
     
        </li>
        <li>
          <span>
            <label>Pincode*</label>
            <input class="input" type="text" placeholder="Pincode"  appOnlynumber
                formControlName="pincode" maxlength="6" autocomplete="off"
                (input)="maxLengthSix($event)" inputmode="numeric"
                 />
                </span>
            <small class="error" *ngIf="submitted && myForm.pincode.errors?.required">
                <sup>*</sup>Please enter your Pincode
            </small>
            <small class="error" *ngIf="submitted && myForm.pincode.errors?.minlength">
                <sup>*</sup>Please enter 6 digit Pincode
            </small>
  
        </li>
        <li class="fullwidth">
            <span>
        <label for="">Enter required details</label>
        <input type="text" formControlName="query" placeholder="Type your query here">
        </span>
        <!-- <small class="error" *ngIf="submitted && myForm.query.errors?.required">
            <sup>*</sup>This field is mandatory
        </small> -->
    
        </li>
    </ul>
    <div class="submitBtncheckobx">
        <!-- <input type="checkbox" formControlName="claims"> -->
        <span></span>
     
     <em style="font-size: 12px;">  <sup>*</sup>By submitting this form, you agree to be contacted by Sales Representative from
        Dell Technologies, its group of companies, or exclusive stores. For more details on our
        information practices, see our Privacy Statement. You can unsubscribe at any time.</em>
    
        <div>
            <a href="javascript:void" class="yellowBtn large" (click)=onSubmit($event,content)>{{submitText}}
                <img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=ev5teqd&ct=0:031y6qj&fmt=3"/>
            </a>
        </div>
    </div>
</div>
<section class="mainBanner">
    <app-banner></app-banner>
</section>
<app-store-list *ngIf="storeInfo" [storeInfoDetail]="storeInfo"></app-store-list>


<ng-template #content let-c="close" let-d="dismiss">
  <div class="thankYoumsg">
      <button class="btn-close thankyou-btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      <h3 class="modal-title" id="modal-basic-title">Thank You</h3>

  </div>
  <div class="modal-body text-center">
      <p><strong>{{description}}</strong></p>
  </div>
</ng-template>